import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    INIT_URL,
    // SIGNOUT_USER_SUCCESS,
    USER_TOKEN_SET,
    TYPE_USER_SET,
    USER_INFO_SET, SIGNOUT_USER_SUCCESS
} from '../constants/ActionTypes';
import { requestGql } from 'constants/Request';
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const alertSweet = withReactContent(Swal)

export const setInitUrl = url => {
    return {
        type: INIT_URL,
        payload: url
    };
};

export const userSignUp = ({ name, email, password }) => {
    if (!name) {
        return alertSweet('Please enter name');
    }
    if (!email) {
        return alertSweet('Please enter email');
    }
    if (!password) {
        return alertSweet('Please enter password');
    }
    return dispatch => {
        dispatch({ type: FETCH_START });
        // axios.post('auth/register', {
        //   email: email,
        //   password: password,
        //   name: name
        // }
        // ).then(({ data }) => {
        //   console.log("data:", data);
        //   if (data.result) {
        //     localStorage.setItem("mhc", JSON.stringify(data.token.access_token));
        //     dispatch({ type: FETCH_SUCCESS });
        //     dispatch({ type: USER_TOKEN_SET, payload: data.token.access_token });
        //     dispatch({ type: USER_DATA, payload: data.user });
        //   } else {
        //     console.log("payload: data.error", data.error);
        //     dispatch({ type: FETCH_ERROR, payload: "Network Error" });
        //   }
        // }).catch(function (error) {
        //   dispatch({ type: FETCH_ERROR, payload: error.message });
        //   console.log("Error****:", error.message);
        // });
    };
};

export const userSignIn = ({ email, password }) => {
    return dispatch => {
        if (!email) {
            return alertSweet('Please enter email');
        }
        if (!password) {
            return alertSweet('Please enter password');
        }
        dispatch({ type: FETCH_START });
        const mutations = `
    mutation adminSignin($email: String, $password: String) {
      adminSignin(input: { email: $email, password: $password }) {
        token
        status
        userType
      }
    }
    `;
        const variables = {
            email,
            password
        };
        requestGql(mutations, variables)
            .then(data => {
                console.log('userSignIn: ', data);
                if (data.adminSignin && data.adminSignin.token) {
                    const jwtToken = jwtDecode(data.adminSignin.token);
                    if(jwtToken.role_id === 4){
                        alertSweet("Login fail")
                        return ;
                    }
                    localStorage.setItem('mhc', data.adminSignin.token);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: USER_TOKEN_SET,
                        payload: data.adminSignin.token
                    });
                    dispatch({
                        type: TYPE_USER_SET,
                        payload: data.adminSignin.userType
                    });
                } else {
                    // dispatch({ type: FETCH_ERROR, payload: 'Login fail' });
                    alertSweet(data.adminSignin.status || "Login fail")
                }
            })
            .catch(function(error) {
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log('Error****:', error.message);
            });
    };
};

export const getUser = () => {
    return dispatch => {
        dispatch({ type: FETCH_START });
        let query = `query{
            adminAvatarDetail{
                name,
                image,
                userType,
                user_id
            }
        }`;
        requestGql(query)
            .then(data => {
                if (data.adminAvatarDetail) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: TYPE_USER_SET,
                        payload: data.adminAvatarDetail.userType
                    });
                    dispatch({
                        type: USER_INFO_SET,
                        payload: {
                            image: data.adminAvatarDetail.image,
                            name: data.adminAvatarDetail.name,
                            user_id: data.adminAvatarDetail.user_id
                        }
                    });
                }
            })
            .catch(function(error) {
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log('Error****:', error.message);
            });
    };
};

export const userSignOut = () => {
    return (dispatch) => {
        const query = `mutation { 
            logoutAdmin
        }`;

        requestGql(query)
            .then((data) => {
                if (data.logoutAdmin) {
                    localStorage.removeItem('mhc');
                    dispatch({
                    type: SIGNOUT_USER_SUCCESS,
                    payload: null
                });
                }
            })
            .catch(function (error) {
                console.log('Error****:', error.message);
            });
    };
};

export const userSignOutToken = () => {
    return (dispatch) => {
            localStorage.removeItem('mhc');
            dispatch({
            type: SIGNOUT_USER_SUCCESS,
            payload: null
        });
    };
};
